<template>
  <div class="browe page">
    <div class="page-header">
      <div v-if="($mq.resize && $mq.above('769px'))" class="container">
        <h1 class="title">{{ $t('pagetitle.browse') }}</h1>
        <el-input placeholder="Search Beer or Brewery" v-model="searchBeer" @keyup.enter.native="onSearch()" class="input-with-select">
          <el-button type="primary" slot="append" icon="el-icon-search" @click.native.prevent="onSearch()"></el-button>
        </el-input>
      </div>
      <div v-else class="m-container">
        <el-input placeholder="Search Beer or Brewery" v-model="searchBeer" @keyup.enter.native="onSearch()" class="input-with-select">
          <el-button type="primary" slot="append" icon="el-icon-search" @click.native.prevent="onSearch()"></el-button>
        </el-input>
      </div>
    </div>
    <div class="page-body" v-loading="loading">
      <div class="container">
        <el-row class="action" type="flex" justify="center">
          <el-button class="orange-button" @click="onAllClick()">
            <i class="fa fa-bars"></i>
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.all') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onCoreClick()" :class="{ 'orange-button-reverse': core }">
            <i :class="{ 'active' : core }" class="custom-icon icon-core" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.core') : '' }}
          </el-button>
          <!-- <el-button class="orange-button" @click="onPromoClick()" :class="{ 'orange-button-reverse': promo }">
            <i :class="{ 'active' : promo }" class="custom-icon icon-core" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.promo') : '' }}
          </el-button> -->
          <el-button class="orange-button" @click="onBreweryClick()">
            <i class="custom-icon icon-brewery" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.brewery') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onStyleClick()">
            <i class="custom-icon icon-style" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.style') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onRegionClick()">
            <i class="custom-icon icon-region" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.region') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onBottleClick" :class="{ 'orange-button-reverse': bottle }">
            <i :class="{ 'active' : bottle }" class="custom-icon icon-bottle" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.bottle') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onKegClick" :class="{ 'orange-button-reverse': keg }">
            <i :class="{ 'active' : keg }" class="custom-icon icon-keg" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.keg') : '' }}
          </el-button>
        </el-row>
        <el-row type="flex" justify="center">
          <span v-if="isCompleted && (products.length < 1) && !isError">{{ $t('error.noresults') }}</span>
          <span v-if="isCompleted && isError">{{ $t('error.somethingwrong') }}</span>
        </el-row>
        <el-row type="flex" justify="center">
          <div class="products">
            <div class="item" v-for="(product, index) in products" :key="index">
              <div class="item-padding">
                <div class="item-container">
                  <a class="poster" :title="product.description" @click="onItemClick($t('route.beer'), product)">
                    <div v-if="product.is_promo" class="ribbon-wrapper-red"><div class="ribbon-red">PROMO</div></div>
                  </a>
                  <div v-if="product.is_core" class="ribbon-wrapper-core"><div class="ribbon-core">CORE</div></div>
                  <a class="poster" :title="product.description" @click="onItemClick($t('route.beer'), product)">
                    <img :src="product.beer_image ? product.beer_image.path : '/static/beer-placeholder.jpg'" />
                  </a>
                  <div class="item-brewery">
                    <a :title="product.description2" @click="onItemClick($t('route.beer'), product)">
                      <span>{{ product.description2 }}</span>
                    </a>
                  </div>
                  <div class="item-desc">
                    <a :title="product.description" @click="onItemClick($t('route.beer'), product)">
                      <h1>{{ product.description }}</h1>
                    </a>
                    <h2>{{ $t('currency.malaysia') }} {{ product.user_price ? product.user_price : product.refprice }}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-row>
        <el-row type="flex" justify="center">
          <el-pagination
            class="pagination"
            background
            layout="prev, pager, next"
            :page-size="pagesize"
            :total="total"
            :pager-count="($mq.resize && $mq.below('767px')) ? 5 : 7"
            :current-page="currentpage"
            @current-change="onPageChange">
          </el-pagination>
        </el-row>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
      <div class="button-wrapper">
        <div class="buttons" v-for="(item, index) in items" :key="index">
          <el-button round class="dialogbutton" @click="onFilterClick(item)">{{ item.name }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Site from '@/api/site'
export default {
  name: 'browse',
  components: {
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    breweryId: {
      default: ''
    },
    styleId: {
      default: ''
    },
    region: {
      default: ''
    },
    core: {
      default: 0
    },
    keg: {
      default: 0
    },
    bottle: {
      default: 0
    },
    promo: {
      default: 0
    },
    page: {
      default: 1
    },
    search: {
      default: ''
    }
  },
  watch: {
    computedProperty () {
      let query
      if (this.core) {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, isCore: this.core }
      } else if (this.keg) {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, isKeg: this.keg }
      } else if (this.bottle) {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, isBottle: this.bottle }
      } else if (this.promo) {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, promo: this.promo }
      } else if (this.breweryId) {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, breweryId: this.breweryId }
      } else if (this.styleId) {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, styleId: this.styleId }
      } else if (this.region) {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, countryId: this.region }
      } else if (this.search) {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, beer: this.search }
      } else {
        query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid }
      }
      this.reload(query)
    }
  },
  computed: {
    computedProperty () {
      return [this.id, this.breweryId, this.styleId, this.region, this.core, this.keg, this.bottle, this.page, this.search].join()
    }
  },
  data () {
    return {
      products: [],
      loading: true,
      isCompleted: false,
      isError: false,
      // isCore: 0,
      items: [],
      countries: [],
      breweries: [],
      styles: [],
      dialogTitle: '',
      dialogTableVisible: false,
      pagesize: 0,
      total: 0,
      lastpage: 1,
      currentpage: 1,
      searchBeer: ''
    }
  },
  mounted () {
    let query
    if (this.core) {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, isCore: this.core }
    } else if (this.keg) {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, isKeg: this.keg }
    } else if (this.bottle) {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, isBottle: this.bottle }
    } else if (this.promo) {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, promo: this.promo }
    } else if (this.breweryId) {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, breweryId: this.breweryId }
    } else if (this.styleId) {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, styleId: this.styleId }
    } else if (this.region) {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, countryId: this.region }
    } else if (this.search) {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, beer: this.search }
    } else {
      query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid }
    }
    this.reload(query)
  },
  methods: {
    reload (query) {
      this.getBeer(query)
      this.getBreweries()
      this.getStyles()
      this.getCountry()
    },
    // onBreweryNameLoad () {
    //   Site.getBrands().then((res) => {
    //     this.breweries = res.result
    //     let breweryId
    //     this.breweries.forEach((item) => {
    //       if (item.name.toLowerCase() === this.name.toLowerCase()) {
    //         breweryId = item.id
    //       }
    //     })
    //     if (breweryId) {
    //       let query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, breweryId }
    //       this.getBeer(query)
    //     } else {
    //       this.loading = false
    //       this.isCompleted = true
    //     }
    //   }).catch((err) => {
    //     console.log(err)
    //   })
    // },
    getBreweries () {
      // let query = { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid }
      // console.log('query,', query)
      // Site.getBrands(query).then((res) => {
      Site.getBrands().then((res) => {
        this.breweries = res.result
        // console.log(res.result)
      }).catch((err) => {
        console.log(err)
      })
    },
    getStyles () {
      Site.getStyles().then((res) => {
        this.styles = res.result
      }).catch((err) => {
        console.log(err)
      })
    },
    getCountry () {
      Site.getCountry().then((res) => {
        this.countries = res.result
      }).catch((err) => {
        console.log(err)
      })
    },
    getBeer (data) {
      this.loading = true
      // console.log('getBeer', data)
      Site.getBeer(this.page, data).then((res) => {
        this.total = res.result.total
        this.pagesize = res.result.per_page
        this.lastpage = res.result.last_page
        this.currentpage = res.result.current_page
        // console.log('res: ', res)
        // console.log('res: ', res.result.data)
        res.result.data.forEach((val) => {
          let promoprice
          let userprice
          // console.log(val.description)
          // val.stockslist.forEach((item, i) => {
          //   console.log('branch:', item.branch.label)
          //   console.log('qty:', item.qty)
          // })
          val.prices.forEach((price) => {
            if (price.uom === 'BOTTLE') {
              if (price.group && price.group.xml_name === 'PROMO') {
                promoprice = price.stockvalue
              } else {
                userprice = price.stockvalue
              }
            } else if (price.uom === 'KEG') {
              if (price.group && price.group.xml_name === 'PROMO') {
                promoprice = price.stockvalue
              } else {
                userprice = price.stockvalue
              }
            }
          })
          val.user_price = promoprice !== undefined ? promoprice : (userprice !== undefined ? userprice : val.refprice)
        })
        this.products = res.result.data
        this.loading = false
        this.isCompleted = true
      }).catch((err) => {
        this.loading = false
        this.isCompleted = true
        this.isError = true
        console.log(JSON.stringify(err))
        console.log(err.response)
      })
    },
    onPageChange (page) {
      let query = this.generateParams(page)
      this.$router.push({ path: `/browse`, query })
    },
    onItemClick (name, obj) {
      this.$router.push({ path: `/beer`, query: { id: obj.id, name: obj.description, breweryId: obj.taps_brewery_id, styleId: obj.taps_style_id } })
    },
    onAllClick () {
      let query = { page: 1 }
      this.$router.push({ path: `/browse`, query })
    },
    onKegClick () {
      let keg = this.keg ? 0 : 1
      let query = { keg, page: 1 }
      this.$router.push({ path: `/browse`, query })
    },
    onBottleClick () {
      let bottle = this.bottle ? 0 : 1
      let query = { bottle, page: 1 }
      this.$router.push({ path: `/browse`, query })
    },
    onCoreClick () {
      let core = this.core ? 0 : 1
      let query = { core, page: 1 }
      this.$router.push({ path: `/browse`, query })
    },
    onPromoClick () {
      let promo = this.promo ? 0 : 1
      let query = { promo, page: 1 }
      this.$router.push({ path: `/browse`, query })
    },
    onBreweryClick () {
      this.dialogTitle = this.$t('dialogTitle.brewery')
      this.dialogTableVisible = true
      this.items = this.breweries
    },
    onStyleClick () {
      this.dialogTitle = this.$t('dialogTitle.style')
      this.dialogTableVisible = true
      this.items = this.styles
    },
    onRegionClick () {
      this.dialogTitle = this.$t('dialogTitle.region')
      this.dialogTableVisible = true
      this.items = this.countries
    },
    onSearch () {
      let query = { page: 1, search: this.searchBeer }
      this.$router.push({ path: `/browse`, query })
    },
    onFilterClick (item) {
      let page = 1
      let query
      if (this.dialogTitle === this.$t('dialogTitle.brewery')) {
        query = { page, breweryId: item.id }
      } else if (this.dialogTitle === this.$t('dialogTitle.style')) {
        query = { page, styleId: item.id }
      } else if (this.dialogTitle === this.$t('dialogTitle.region')) {
        query = { page, region: item.id }
      }
      this.$router.push({ path: `/browse`, query })
      this.dialogTitle = ''
      this.dialogTableVisible = false
    },
    generateParams (page) {
      let query
      if (this.core) {
        query = { page, core: this.core }
      } else if (this.keg) {
        query = { page, keg: this.keg }
      } else if (this.bottle) {
        query = { page, bottle: this.bottle }
      } else if (this.promo) {
        query = { page, promo: this.promo }
      } else if (this.breweryId) {
        query = { page, breweryId: this.breweryId }
      } else if (this.styleId) {
        query = { page, styleId: this.styleId }
      } else if (this.region) {
        query = { page, region: this.region }
      } else if (this.search) {
        query = { page, search: this.search }
      } else {
        query = { page }
      }
      // console.log(query)
      return query
    }
  }
}
</script>
<style lang="scss">

.input-with-select {
  .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #ECB039;
  }
  .el-input__inner {
    color: #1C1C1C;
    border: 1px solid #ECB039;
  }
  .el-input-group__append {
    background-color: #ECB039;
    color: #1C1C1C;
    border: 1px solid #ECB039;
  }
  .el-input-group__append button.el-button {
    border-color: transparent;
    background-color: #ECB039;
  }
}
</style>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.browe {
  .page-header {
    padding: 0;
    @media (min-width: 768px) {
      padding: 0 25px;
    }
    .container {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
    }
    .m-container {
      display: flex;
      justify-content: center;
      padding: 10px;
      width: 100%;
    }
    .filter-button {
      margin-left: 10px;
    }
    .input-with-select {
      max-width: 100%;
      @media (min-width: 768px) {
        max-width: 250px;
      }
    }
  }
  .page-body {
    padding: 0 10px;
    @media (min-width: 768px) {
      padding: 0 15px;
    }
    .container {
      padding-bottom: 25px;
    }
  }
  .action {
    // padding: 20px;
    .el-button+.el-button {
      margin-top: 20px;
      margin-left: 5px;
      margin-right: 5px;
    }
    .el-button {
      margin-top: 20px;
      margin-left: 5px;
      margin-right: 5px;
    }
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  .orange-button {
    // padding: 15px;
    width: auto;
  }
  .el-button span {
    display: flex;
    align-items: center;
  }
  .orange-button {
    .custom-icon {
      background-repeat: no-repeat;
      background-size:contain;
      display: inline-block;
      width: 16px;
      height: 16px;
    }
  }
  .orange-button-reverse {
    .custom-icon {
    }
  }
  .icon-keg {
    background-image: url(/static/icon-keg-black.svg);
  }
  .icon-keg.active {
    background-image: url(/static/icon-keg-black2.svg);
  }
  .icon-bottle {
    background-image: url(/static/icon-bottle-black.svg);
  }
  .icon-bottle.active {
    background-image: url(/static/icon-bottle-black2.svg);
  }
  .icon-core {
    background-image: url(/static/icon-core-black.svg);
  }
  .icon-core.active {
    background-image: url(/static/icon-core-black2.svg);
  }
  .icon-brewery {
    background-image: url(/static/icon-brewery-black.svg);
  }
  .icon-style {
    background-image: url(/static/icon-style-black.svg);
  }
  .icon-region {
    background-image: url(/static/icon-region-black.svg);
  }
  .button-wrapper {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
    .buttons {
      width: 50%;
      justify-content: center;
      align-items: center;
      display: flex;
      .dialogbutton {
        width: 90%;
        margin-bottom: 15px;
      }
    }
  }
  .products {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
    // column-count: 1;
    @media (min-width: 768px) {
      // column-count: 3;
    }
    .item {
      width: 50%;
      text-align: center;

      @media (min-width: 768px) {
        width: 20%;
      }

      .item-padding {
        padding: 5px;
        @media (min-width: 768px) {
          padding: 10px;
        }
        .item-container {
          background: #fff;
          border: 1px solid #ccc;
          position: relative;
          .poster {
            & img {
              vertical-align: top;
            }
          }
          .item-brewery {
            background-color: $black-color;
            color: $white-color;
            font-weight: bold;
            padding: 3px 0;
            font-size: 14px;
          }
          a {
            cursor: pointer;
            & > h1 {
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              margin: 10px 0;
              @media (max-width: 767px) {
                font-size: 16px;
                margin: 5px 0;
              }
            }
          }
          & > .item-desc {
            padding: 0 15px;
            & > h2 {
              margin: 10px 0;
            }
          }
        }
      }
      h1 {
        font-size: 18px;
      }
      h2 {
        font-size: 16px;
        font-weight: normal;
        @media (max-width: 767px) {
          font-size: 14px;
          margin: 5px 0 10px 0;
        }
      }
      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/browse/index.vue